import { render } from "./BulkRecycle.vue?vue&type=template&id=bac5b8c8&scoped=true"
import script from "./BulkRecycle.vue?vue&type=script&lang=ts"
export * from "./BulkRecycle.vue?vue&type=script&lang=ts"

import "./BulkRecycle.vue?vue&type=style&index=0&id=bac5b8c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bac5b8c8"

export default script